export class DistributionTrend {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "quantiles",
            "baseName": "quantiles",
            "type": "Array<QuantileTrendSeries>",
            "format": ""
        },
        {
            "name": "categories",
            "baseName": "categories",
            "type": "Array<CategoryTrendSeries>",
            "format": ""
        },
        {
            "name": "distinct",
            "baseName": "distinct",
            "type": "MetricTimeseries",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DistributionTrend.attributeTypeMap;
    }
    constructor() {
    }
}
